import { render, staticRenderFns } from "./NotificationMenu.vue?vue&type=template&id=58e551f8&scoped=true"
import script from "./NotificationMenu.vue?vue&type=script&lang=js"
export * from "./NotificationMenu.vue?vue&type=script&lang=js"
import style0 from "./NotificationMenu.vue?vue&type=style&index=0&id=58e551f8&prod&scoped=true&lang=css"
import style1 from "./NotificationMenu.vue?vue&type=style&index=1&id=58e551f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e551f8",
  null
  
)

export default component.exports